export default __webpack_public_path__ + "static/ux.ananas-a064accb3108ef8009135de2234cf912.webp";